import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BadgeCheckIcon } from 'lucide-react';
export function GuaranteeBand() {
  return <section aria-label="Guarantee" className="relative overflow-hidden bg-forge-orange" data-id="element-175" data-mp="2zi7gniv4num2">
      <div className="absolute inset-0 hatch-dark opacity-20" aria-hidden="true" data-id="element-176" data-mp="33jj4biufy5rm" />

      <div className="relative mx-auto flex max-w-8xl flex-col items-start gap-7 px-5 py-12 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:px-10 lg:py-14" data-id="element-177" data-mp="33ldga7nqinjk">
        <div className="flex items-start gap-5" data-id="element-178" data-mp="2bswkyfsmwqes">
          <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-ink" data-id="element-179" data-mp="2fu817upmbzab">
            <BadgeCheckIcon className="h-7 w-7 text-forge-orange" aria-hidden="true" data-id="element-180" data-mp="2kt1i7x4468f8" />
          </span>
          <div data-id="element-181" data-mp="3r9dj45ybm4ei">
            <p className="font-mono text-[9.5px] uppercase tracking-[0.24em] text-ink/70" data-id="element-182" data-mp="3r9n239ky7bap">Our guarantee</p>
            <h2 className="mt-2 max-w-2xl font-display text-[1.6rem] font-extrabold leading-tight tracking-[-0.01em] text-ink sm:text-[2rem]" data-id="element-183" data-mp="210dmhshiwh">
              Love your site or get your money back.
            </h2>
            <p className="mt-2 max-w-xl text-[14.5px] font-medium leading-relaxed text-ink/75" data-id="element-184" data-mp="1ypg0k1vsqq4k">
              Every build is backed by a 30-day money-back option. If it is not right, we make it right — or you are not stuck
              with it.
            </p>
          </div>
        </div>

        <motion.div whileHover={{
        y: -2
      }} className="shrink-0" data-id="element-185" data-mp="1kpezalbmdgok">
          <Link to="/#get-started" className="group inline-flex items-center gap-2 rounded-xl bg-ink px-6 py-4 text-[15px] font-bold text-white" data-id="element-186" data-mp="1fxwz3zhf7k4n">
            Start your project
            <ArrowRightIcon className="h-4 w-4 text-forge-orange transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-187" data-mp="15zzahavnflbi" />
          </Link>
        </motion.div>
      </div>
    </section>;
}